import { useContext, useState } from 'react';
import { UserContext } from '../../context/userContext';
import FullScreen from '../../components/Common/FullScreen/FullScreen';
import Container from '../../components/Common/Container/Container';
import { Spacing } from '../../types/appTypes';
import AccountDetails from '../../components/Account/AccountDetails/AccountDetails';
import NotificationSettings from '../../components/Account/NotificationSettings/NotificationSettings';
import css from './AccountPage.module.css';

const AccountPage = () => {
  const { user } = useContext(UserContext);
  const [activeTab, setActiveTab] = useState('details');
  console.log("user", user);

  return (
    <FullScreen background="color">
      <Container margin={[Spacing.Auto]} secondaryClass={css.container}>
        <h1 className={css.title}>My Account</h1>
        
        <div className={css.tabsContainer}>
          <button 
            className={`${css.tabButton} ${activeTab === 'details' ? css.active : ''}`}
            onClick={() => setActiveTab('details')}
          >
            Account Details
          </button>
          <button 
            className={`${css.tabButton} ${activeTab === 'notifications' ? css.active : ''}`}
            onClick={() => setActiveTab('notifications')}
          >
            Notification Settings
          </button>
        </div>
        
        <div className={css.contentContainer}>
          {activeTab === 'details' ? (
            <AccountDetails user={user} />
          ) : (
            <NotificationSettings />
          )}
        </div>
      </Container>
    </FullScreen>
  );
};

export default AccountPage;